/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { USER_TYPE } from '../../helper/constant/userType';
import MobileSearchOverlay from './MobileSearchOverlay';
import './MobileBottomNav.css';

function MobileBottomNav({
    permitdata,
    app_hostname,
    mycartlen,
    myorderlen,
    messages_chat_unread,
    buyer_products,
    productCatalog,
    islogin,
}) {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('home');
    const [searchOpen, setSearchOpen] = useState(false);
    const catalog = productCatalog || buyer_products;

    const shopHomeLink =
        permitdata?.user_type === USER_TYPE.SELLER
            ? '/myshop/seller/jobtodo'
            : '/myshop/buyer/payment';

    useEffect(() => {
        const path = location.pathname;
        if (path.includes('/marketplace/mycart')) {
            setActiveTab('cart');
        } else if (path.includes('/jobs')) {
            setActiveTab('jobs');
        } else if (path.includes('/marketplace')) {
            setActiveTab('home');
        } else if (path.includes('/myshop')) {
            setActiveTab('myshop');
        } else if (path.includes('/me')) {
            setActiveTab('me');
        } else {
            setActiveTab('home');
        }
    }, [location]);

    useEffect(() => {
        document.body.classList.add('has-mobile-nav');
        return () => {
            document.body.classList.remove('has-mobile-nav');
        };
    }, []);

    useEffect(() => {
        setSearchOpen(false);
    }, [location]);

    function generate_token(length) {
        var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
        var b = [];
        for (var i = 0; i < length; i++) {
            var j = (Math.random() * (a.length - 1)).toFixed(0);
            b[i] = a[j];
        }
        return b.join('');
    }

    const isLoggedIn =
        permitdata !== null &&
        permitdata.role !== 'guest' &&
        permitdata.token !== '' &&
        permitdata.token !== '-';

    const isJobOnlyLoggedIn =
        sessionStorage.getItem('meya-job-loggedin') === 'true' && !isLoggedIn;

    return (
        <>
            <nav className='mobile-bottom-nav' role='navigation' aria-label='เมนูหลัก'>
                <Link
                    to={
                        isJobOnlyLoggedIn
                            ? '/jobs'
                            : '/marketplace?category=รวมสินค้า'
                    }
                    className={
                        'mobile-bottom-nav__item' +
                        (activeTab === 'home' || activeTab === 'jobs' ? ' active' : '')
                    }
                    aria-label={isJobOnlyLoggedIn ? 'หางาน' : 'หน้าแรก'}
                >
                    <div className='mobile-bottom-nav__icon-wrap'>
                        <i
                            className={
                                'mobile-bottom-nav__icon ' +
                                (isJobOnlyLoggedIn ? 'fas fa-briefcase' : 'fas fa-home')
                            }
                        ></i>
                    </div>
                    <span className='mobile-bottom-nav__label'>
                        {isJobOnlyLoggedIn ? 'หางาน' : 'หน้าแรก'}
                    </span>
                </Link>

                {isJobOnlyLoggedIn ? (
                    <Link
                        to='/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu'
                        className={
                            'mobile-bottom-nav__item' + (activeTab === 'home' && location.pathname.includes('/marketplace') ? ' active' : '')
                        }
                        aria-label='ดูร้านค้า'
                    >
                        <div className='mobile-bottom-nav__icon-wrap'>
                            <i className='mobile-bottom-nav__icon fas fa-store'></i>
                        </div>
                        <span className='mobile-bottom-nav__label'>ดูร้านค้า</span>
                    </Link>
                ) : isLoggedIn ? (
                    <Link
                        to={shopHomeLink}
                        className={'mobile-bottom-nav__item' + (activeTab === 'myshop' ? ' active' : '')}
                        aria-label={'ร้านค้าของฉัน' + (myorderlen > 0 ? ' ' + myorderlen + ' รายการ' : '')}
                    >
                        <div className='mobile-bottom-nav__icon-wrap'>
                            <i className='mobile-bottom-nav__icon ec ec-user'></i>
                            {myorderlen > 0 && (
                                <span className='mobile-bottom-nav__badge'>
                                    {myorderlen > 99 ? '99+' : myorderlen}
                                </span>
                            )}
                        </div>
                        <span className='mobile-bottom-nav__label'>ร้านค้า</span>
                    </Link>
                ) : (
                    <Link
                        to='/'
                        className='mobile-bottom-nav__item'
                        aria-label='เข้าสู่ระบบ'
                    >
                        <div className='mobile-bottom-nav__icon-wrap'>
                            <i className='mobile-bottom-nav__icon ec ec-user'></i>
                        </div>
                        <span className='mobile-bottom-nav__label'>เข้าสู่ระบบ</span>
                    </Link>
                )}

                {!isJobOnlyLoggedIn && (
                    <Link
                        to={
                            isLoggedIn
                                ? '/marketplace/mycart?cart=' + generate_token(20)
                                : '/marketplace?category=รวมสินค้า'
                        }
                        className={'mobile-bottom-nav__item' + (activeTab === 'cart' ? ' active' : '')}
                        aria-label='ตะกร้า'
                    >
                        <div className='mobile-bottom-nav__icon-wrap'>
                            <i className='mobile-bottom-nav__icon fas fa-shopping-cart'></i>
                            {mycartlen > 0 && (
                                <span className='mobile-bottom-nav__badge'>
                                    {mycartlen > 99 ? '99+' : mycartlen}
                                </span>
                            )}
                        </div>
                        <span className='mobile-bottom-nav__label'>ตะกร้า</span>
                    </Link>
                )}

                {(isLoggedIn || isJobOnlyLoggedIn) && (
                    <Link
                        to={isJobOnlyLoggedIn ? '/jobs/profile' : '/me'}
                        className={'mobile-bottom-nav__item' + (activeTab === 'me' ? ' active' : '')}
                        aria-label='ฉัน'
                    >
                        <div className='mobile-bottom-nav__icon-wrap'>
                            <i className={'mobile-bottom-nav__icon ' + (activeTab === 'me' ? 'fas fa-user' : 'far fa-user')}></i>
                        </div>
                        <span className='mobile-bottom-nav__label'>ฉัน</span>
                    </Link>
                )}
            </nav>

            <MobileSearchOverlay
                isOpen={searchOpen}
                onClose={() => setSearchOpen(false)}
                permitdata={permitdata}
                app_hostname={app_hostname}
                productCatalog={catalog}
                islogin={islogin}
            />
        </>
    );
}

export default MobileBottomNav;
